import { DungChungService } from '../../../../nfc/dung-chung/__services/dung-chung.service';
import { CommonConFig } from '../../../../nfc/dung-chung/__model/common_config.model';

import { TokenStorage } from '../../../../../../core/auth/_services/token-storage.service';
import { SubheaderService } from '../../../../../../core/_base/layout/services/subheader.service';
import { TimKiemNangCaoService } from './service/tim-kiem-nang-cao.service';
import { Component, OnInit, ElementRef, ViewChild, ChangeDetectionStrategy, ChangeDetectorRef, HostListener, ViewChildren, Inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
// Material
import { MatPaginator, MatSort, MatDialog, MatTableDataSource, MatMenuTrigger, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { SelectionModel } from '@angular/cdk/collections';
import { CdkDragStart, CdkDropList, moveItemInArray } from '@angular/cdk/drag-drop';
// RXJS
import { tap, debounceTime, distinctUntilChanged, filter } from 'rxjs/operators';
import { merge, BehaviorSubject, fromEvent } from 'rxjs';
//Datasource
//Service
import { TimKiemNangCaoModel } from './model/tim-kiem-nang-cao.model';
import { TimKiemNangCaoDataSource } from './datasource/tim-kiem-nang-cao.datasource';
import { LayoutUtilsService, QueryParamsModel } from '../../../../../../core/_base/crud';
import { environment } from '../../../../../../../environments/environment';
import { DynamicSearchFormService } from '../../../../components/dynamic-search-form/dynamic-search-form.service';
import { FunctionPublic } from '../../../dung-chung/__function/common_function';
import { eventTarget } from '@amcharts/amcharts4/.internal/core/utils/DOM';
import { YeuCauDuyetGiaConfig } from '../yeu-cau-duyet-gia-model/yeu-cau-duyet-gia.model';
//Model


@Component({
	selector: 'm-tim-kiem-nang-cao',
	templateUrl: './tim-kiem-nang-cao.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [DatePipe]
})
export class TimKiemNangCaoListComponent implements OnInit {
	// Config Form 
	CONFIG: CommonConFig;

	isChange: boolean = false;		// Trường kiểm tra dialog có cập nhập - thay đổi dữ liệu hay không
	saveAddedTTHV: number[] = [];
	viewLoading = false;
	//#region Table fields
	dataSource: TimKiemNangCaoDataSource;
	displayedColumns = [];
	availableColumns = [
		{
			stt: 1,
			name: 'select',
			displayName: 'Check chọn',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 1,
			name: '#',
			displayName: '#',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 2,
			name: 'SOPHIEU',
			displayName: 'Số phiếu',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 3,
			name: 'MAKH',
			displayName: 'Mã KH',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 4,
			name: 'TENKH',
			displayName: 'Tên KH',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 5,
			name: 'MAHH',
			displayName: 'Mã HH',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 6,
			name: 'TENHH',
			displayName: 'Tên HH',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 12,
			name: 'KHOANGGIA',
			// displayName: 'Khoảng giá',
			displayName: 'Mức giá tối thiểu',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 8,
			name: 'SOLUONG',
			displayName: 'Số lượng',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 9,
			name: 'DVT',
			displayName: 'DVT',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 10,
			name: 'GIAGANNHAT',
			displayName: 'Giá gần nhất',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 11,
			name: 'GIAKHACHHANGMUONGMUON',
			displayName: 'Giá khách hàng mong muốn',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 12,
			name: 'KLSaiSo',
			displayName: '% KL sai số cho phép',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 7,
			name: 'NGAYLAPPHIEU',
			displayName: 'Ngày lập phiếu',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 13,
			name: 'TRANGTHAI',
			displayName: 'Trạng thái',
			alwaysChecked: false,
			isShow: true
		}


	];
	//#endregion Table fields

	//#region Khai báo biến
	@ViewChildren('focus') focus;
	@ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
	@ViewChild('sort1', { static: true }) sort: MatSort;
	@ViewChild('trigger', { static: true }) _trigger: MatMenuTrigger;
	@ViewChild('searchFullText', { static: true }) searchFullText: ElementRef;

	selectedColumns = new SelectionModel<any>(true, this.availableColumns);
	selection = new SelectionModel<TimKiemNangCaoModel>(true, []);
	TimKiemNangCaoResult: TimKiemNangCaoModel[] = [];
	tmpTimKiemNangCaoResult: TimKiemNangCaoModel[] = [];
	originalTimKiemNangCaoResult: TimKiemNangCaoModel[] = [];
	loadingSubject = new BehaviorSubject<boolean>(false);
	loading$ = this.loadingSubject.asObservable();
	saveNewTTHV: number[] = []
	flagHighlight: boolean = false;
	previousIndex: number;
	fixedPoint = 2;
	listdachon: any[] = [];
	//#endregion Khai báo biến

	//#region Filter on grid
	haveFilter: boolean = false;
	filterGroupDataChecked: any = {};
	filterGroupDataCheckedFake: any = {};
	filterGroupData: any = {};
	filterGroupArray: any = {};
	filterText: any = {};
	tmpfilterText: any = {};
	disableButtonFilter: any = {};
	isClearAll: boolean = false;
	idKH:number;
	//#endregion Filter on grid

	//#region Phím tắt
	//#endregion Phím tắt
	/* --------------------------- B2B & B2C ----------------------------*/
	BusinessType: string = "";
	BusinessUrl: string = "";
	BusinessTitle: string = "";
	/* ----------------------------------------------------------------- */
	//#region Constructor

	constructor(
		private TimKiemNangCaoService: TimKiemNangCaoService,
		@Inject(MAT_DIALOG_DATA) public data: any,
		private dungChung: DungChungService,
		public dialog: MatDialog,
		private router: Router,
		private subheaderService: SubheaderService,
		private changeDetect: ChangeDetectorRef,
		private tokenStorage: TokenStorage,
		public dialogRef: MatDialogRef<TimKiemNangCaoListComponent>,
		private dynamicSearchFormService: DynamicSearchFormService,
		private layoutUtilsService: LayoutUtilsService) {
		this.dialogRef.disableClose = true;
		
		const SiteUrl = this.router.url.split("/")[1];
		if ([YeuCauDuyetGiaConfig.B2B.PARAM_REQUEST_PRICE, YeuCauDuyetGiaConfig.B2C.PARAM_REQUEST_PRICE].includes(SiteUrl)) {
		
			let currentConfig = SiteUrl === YeuCauDuyetGiaConfig.B2B.PARAM_REQUEST_PRICE 
				? YeuCauDuyetGiaConfig.B2B 
				: YeuCauDuyetGiaConfig.B2C;
		
			this.BusinessTitle = currentConfig.TITLE_REQUEST_PRICE;
			this.BusinessType = currentConfig.BUSINESS_TYPE;
			this.BusinessUrl = SiteUrl;
		}
	}
	//#endregion Constructor

	//#region Load Data
	ngOnInit() {
		/*Load cấu hình config form */
		this.CONFIG = new CommonConFig();
		this.CONFIG.PAGE_SIZE_LIST = environment.pageSize;
		this.haveFilter = true;

		this.searchFullText.nativeElement.value = this.data.kw;
		this.idKH = this.data.idKH;
		this.listdachon = this.data.data;
		// this.disableButtonFilter['TenNhom'] = true;
		// this.disableButtonFilter['MaLoai'] = true;
		// this.disableButtonFilter['TenLoai'] = true;
		// this.disableButtonFilter['MaHH'] = true;
		// this.disableButtonFilter['TenHH'] = true;
		// this.disableButtonFilter['QuyCach'] = true;

		// this.tmpfilterText = Object.assign({}, this.filterText);

		// this.filterText['TenNhom'] = "";
		// this.filterText['MaLoai'] = "";
		// this.filterText['TenLoai'] = "";
		// this.filterText['MaHH'] = "";
		// this.filterText['TenHH'] = "";
		// this.filterText['QuyCach'] = "";

		// this.filterGroupDataChecked['MaLoai'] = "";
		// this.filterGroupDataChecked['TenLoai'] = "";
		// this.filterGroupDataChecked['MaHH'] = "";
		// this.filterGroupDataChecked['TenHH'] = "";
		// this.filterGroupDataChecked['QuyCach'] = "";

		this.callServiceFilter();

		this.showColumnsInTable();
		this.applySelectedColumns();

		this.dialogRef.keydownEvents().subscribe(event => {
			if (event.key == "Escape") {
				this.back();
			}
			if (event.altKey && event.keyCode == this.CONFIG.BUTTON_FORM.TIEPTUC.KeyCombine.keycode && this.saveAddedTTHV.length > 0) {
				this.isChange = true;
				this.back();
			}
		});


		this.sort.sortChange.subscribe(() => (this.paginator.pageIndex = 0));
		merge(this.sort.sortChange, this.paginator.page)
			.pipe(
				tap(() => {
					this.loadTimKiemNangCaoList();
				})
			)
			.subscribe();

		fromEvent(this.searchFullText.nativeElement, 'keyup')
			.pipe(
				debounceTime(150),
				filter((e: KeyboardEvent) => !(e.altKey && e.keyCode == this.CONFIG.BUTTON_FORM.TIEPTUC.KeyCombine.keycode)),
				distinctUntilChanged(),
				tap(() => {
					setTimeout(() => {
						this.loadTimKiemNangCaoListInit();
					}, 100);
				})
			)
			.subscribe();

		// Init DataSource
		this.dataSource = new TimKiemNangCaoDataSource(this.TimKiemNangCaoService);
		let queryParams = new QueryParamsModel({});


		this.dataSource.entitySubject.subscribe(res => {
			this.TimKiemNangCaoResult = res
			this.tmpTimKiemNangCaoResult = []
			if (this.TimKiemNangCaoResult != null) {
				for (let i = 0; i < this.TimKiemNangCaoResult.length; i++) {
					let tmpElement = new TimKiemNangCaoModel();
					tmpElement.copy(this.TimKiemNangCaoResult[i])
					this.tmpTimKiemNangCaoResult.push(tmpElement);
				}
			}
		});
		this.loadTimKiemNangCaoList();
		this.layoutUtilsService.setUpPaginationLabels(this.paginator);

		let opt = {
			title: 'Tìm kiếm theo: Số phiếu, Mã hàng hóa, Tên hàng',
			searchbox: 'Search',
			controls: [{
				type: 0,
				name: 'Search',
				placeholder: 'Từ khóa',
			}
			]
		}
		this.dynamicSearchFormService.setOption(opt);
		this.dynamicSearchFormService.filterResult.subscribe(value => {
			if (Object.keys(value).length > 0) {
				this.searchFullText.nativeElement.value = value.Search;
				this.loadTimKiemNangCaoList();
			}
			else {
				this.searchFullText.nativeElement.value = "";
				this.loadTimKiemNangCaoList();
			}
		});
	}

	ngAfterViewInit() {
		setTimeout(() => {
			this.searchFullText.nativeElement.focus();
		}, 50);
		//this.focus.first.nativeElement.focus();
		this.changeDetect.detectChanges();
	}
	//#endregion Load Data

	async callServiceFilter() {
		let res = await this.dungChung.listLoaiHH().toPromise();
		if (res && res.status == 1) {
			var i = 0;
			this.filterGroupDataChecked['TenNhom'] = res.data.map(x => {
				i = i + 1;
				return {
					id: i,
					name: x.TenLoaiHH,
					value: x.IdLoaiHH,
					checked: false,
				}
			});
			this.filterGroupDataCheckedFake = Object.assign({}, this.filterGroupDataChecked);

		} else {

			this.layoutUtilsService.showErorr(res.error.message);
		}
	}

	//#region Load danh sách
	loadTimKiemNangCaoListPagePre(highlight: boolean = false) {
		this.originalTimKiemNangCaoResult = [];
		if (highlight == false) this.saveNewTTHV = [];
		this.selection.clear();
		this.paginator.pageIndex = (this.paginator.pageIndex > 0) ? this.paginator.pageIndex - 1 : 0;
		const queryParams = new QueryParamsModel(
			this.filterConfiguration(),
			this.sort.direction,
			this.sort.active,
			this.paginator.pageIndex,
			this.paginator.pageSize,
			this.filterGroupData
		);
		this.dataSource.loadTimKiemNangCaos(queryParams);
	}

	loadTimKiemNangCaoList(highlight: boolean = false) {
		this.originalTimKiemNangCaoResult = [];
		if (highlight == false) this.saveNewTTHV = [];
		this.selection.clear();
		const queryParams = new QueryParamsModel(
			this.filterConfiguration(),
			this.sort.direction,
			this.sort.active,
			this.paginator.pageIndex,
			this.paginator.pageSize,
			this.filterGroupData
		);
		this.dataSource.loadTimKiemNangCaos(queryParams);
	}

	loadTimKiemNangCaoListInit(highlight: boolean = false) {
		this.originalTimKiemNangCaoResult = [];
		if (highlight == false) this.saveNewTTHV = [];
		this.selection.clear();
		this.paginator.pageIndex = 0;
		const queryParams = new QueryParamsModel(
			this.filterConfiguration(),
			this.sort.direction,
			this.sort.active,
			this.paginator.pageIndex,
			this.paginator.pageSize,
			this.filterGroupData
		);
		this.dataSource.loadTimKiemNangCaos(queryParams);
	}
	//#endregion Load danh sách

	//#region FILTRATION
	filterConfiguration(): any {
		const filter: any = {};
		filter.keywordssearch = this.searchFullText.nativeElement.value;
		filter.idKH = this.idKH;
		filter.BusinessModel = this.BusinessType
		return filter;
	}
	//#endregion FILTRATION

	//#region Apply selected Column
	IsAllColumnsChecked() {
		const numSelected = this.selectedColumns.selected.length;
		const numRows = this.availableColumns.length;
		return numSelected === numRows;
	}

	CheckAllColumns() {
		if (this.IsAllColumnsChecked()) {
			this.availableColumns.forEach(row => { if (!row.alwaysChecked) this.selectedColumns.deselect(row); });
		} else {
			this.availableColumns.forEach(row => this.selectedColumns.select(row));
		}
	}

	showColumnsInTable() {
		for (let i = 0; i < this.availableColumns.length; i++) {
			if (this.availableColumns[i].isShow == false) {
				this.selectedColumns.toggle(this.availableColumns[i]);
			}
		}
	}

	findIndexColumn(column: string) {
		for (let i = 0; i < this.availableColumns.length; i++) {
			if (this.availableColumns[i].name == column)
				return i;
		}
	}

	dragStarted(event: CdkDragStart, column: string) {
		this.previousIndex = this.findIndexColumn(column);
	}

	dropListDropped(event: CdkDropList, column: string) {

		if (event) {
			moveItemInArray(this.availableColumns, this.previousIndex, this.findIndexColumn(column));
			this.applySelectedColumns();
		}
	}

	applySelectedColumns() {
		let _selectedColumns = this.selectedColumns.selected;
		this.selectedColumns = new SelectionModel<any>(true, this.availableColumns);
		for (let i = 0; i < this.availableColumns.length; i++) {
			this.selectedColumns.toggle(this.availableColumns[i]);
			for (let j = 0; j < _selectedColumns.length; j++) {
				if (this.availableColumns[i].name == _selectedColumns[j].name) {
					this.selectedColumns.toggle(this.availableColumns[i]);
					break;
				}
			}
		}
		const _applySelectedColumns: string[] = [];
		this.selectedColumns.selected.forEach(col => { _applySelectedColumns.push(col.name) });
		this.displayedColumns = _applySelectedColumns;
	}

	menuChange(e: any, type: 0 | 1 = 0) {
		this.layoutUtilsService.menuSelectColumns_On_Off();
	}
	//#endregion Apply selected Column

	checkDashboardRoute() {
		if (this.router.url === '/')
			return true;
		return false;
	}
	//#endregion Kiểm tra người dùng, đường dẫn

	//#region Filter function
	SelectAll(event, col) {
		if (event.checked) {
			this.filterGroupDataCheckedFake[col].forEach(element => {
				element.checked = true;
			});
		}
		else {
			this.filterGroupDataCheckedFake[col].forEach(element => {
				element.checked = false;
			});
		}
	}
	isColumnSelectAll(col) {
		if (this.filterGroupDataCheckedFake[col]) {
			let lst_checked = this.filterGroupDataCheckedFake[col].filter(opt => opt.checked).map(opt => opt.value);
			if (lst_checked) {
				if (lst_checked.length != this.filterGroupDataCheckedFake[col].length) {
					return false;
				}
				else {
					return true;
				}
			}
			else {
				return false;
			}
		}
		return false;
	}
	LoadDataDropFilter(col) {
		this.tmpfilterText = Object.assign({}, this.filterText);
		if (this.filterGroupDataChecked && this.filterGroupDataCheckedFake && this.filterGroupDataCheckedFake[col] && this.filterGroupDataChecked[col]) {
			this.filterGroupDataCheckedFake[col] = this.filterGroupDataChecked[col].map(x => Object.assign({}, x));
		}
	}
	// isSelect : true list chon | false là nhap text
	disableDoneButton(col, isSelect = true) {
		let countChecked = 0;

		if (isSelect) {
			if (this.filterGroupDataCheckedFake && this.filterGroupDataCheckedFake[col]) {
				for (var elementFake of this.filterGroupDataCheckedFake[col]) {
					if (elementFake.checked) {
						countChecked++;
					}
				}
			}
			if (countChecked > 0) {
				this.disableButtonFilter[col] = false;
			}
			else {
				this.disableButtonFilter[col] = true;
			}
		} else {
			if (this.filterGroupDataCheckedFake && this.filterGroupDataCheckedFake[col]) {
				if (this.filterGroupDataCheckedFake[col].length > 0) {
					this.disableButtonFilter[col] = false;
				}
				else {
					this.disableButtonFilter[col] = true;
				}
			}
		}
	}
	showClearAllButton() {
		let _count = 0;
		for (var key in this.filterGroupArray) {
			if (this.filterGroupArray.hasOwnProperty(key)) {
				if (this.filterGroupArray[key]) {
					let _arrflt = this.filterGroupArray[key].filter(opt => opt.checked);
					if (_arrflt.length == 0 && this.filterGroupArray[key].length == 1) {
						_arrflt = this.filterGroupArray[key].filter(opt => opt);
					}
					_count += _arrflt ? _arrflt.length : 0;
				}
			}
		}
		let _text = "";
		for (var key in this.filterText) {
			if (this.filterText.hasOwnProperty(key)) {
				_text += this.filterText[key];
			}
		}
		if (_count > 0 || _text) {
			this.isClearAll = true;
		}
		else {
			this.isClearAll = false;
		}
	}
	filterHead(col, isSelect = true) {
		if (isSelect) {
			if (this.filterGroupDataCheckedFake && this.filterGroupDataCheckedFake[col]) {
				for (var elementFake of this.filterGroupDataCheckedFake[col]) {

					let index = this.filterGroupDataChecked[col].findIndex(x => x.id == elementFake.id);

					if (index > -1)
						this.filterGroupDataChecked[col][index].checked = elementFake.checked;
				}
				this.filterGroupData[col] = [];
				this.filterGroupArray[col] = [];
				this.filterGroupArray[col] = this.filterGroupDataCheckedFake[col]
					.filter(opt => opt.checked);
				this.filterGroupData[col] = this.filterGroupDataCheckedFake[col]
					.filter(opt => opt.checked).map(op => op.value);

				this.filterGroupDataCheckedFake[col] = this.filterGroupDataChecked[col].map(x => Object.assign({}, x));
				this.tmpfilterText[col] = '';
			}
			this.filterText = Object.assign({}, this.tmpfilterText);
			if (this.filterText) {
				this.filterConfiguration();
			}
			this.loadTimKiemNangCaoListInit();
			this.isClearAll = this.checkFilterHasValue(this.filterGroupDataChecked, 'ALL');
		} else {
			if (this.filterGroupDataCheckedFake) {
				if (!this.filterGroupDataCheckedFake[col]) {
					this.remove('', col, false);
				} else {
					this.filterGroupData[col] = [];
					this.filterGroupArray[col] = [this.filterGroupDataCheckedFake[col]];
					this.filterGroupData[col] = [this.filterGroupDataCheckedFake[col]];
					if (this.filterGroupData[col])
						this.tmpfilterText[col] = '';
				}
			}
			this.filterText = Object.assign({}, this.tmpfilterText);
			if (this.filterText) {
				this.filterConfiguration();
			}
			this.loadTimKiemNangCaoListInit();
			this.isClearAll = this.checkFilterHasValue(this.filterGroupDataCheckedFake, col, false);
			this.filterGroupDataCheckedFake[col] = '';
		}
	}
	remove(item, col, isSelect = true) {
		if (isSelect) {
			let _index = this.filterGroupDataChecked[col].findIndex(x => x.value == item.value);
			if (_index > -1) {
				this.filterGroupDataChecked[col][_index].checked = false;
				this.filterGroupData[col] = [];
				this.filterGroupArray[col] = [];
				this.filterGroupArray[col] = this.filterGroupDataChecked[col]
					.filter(opt => opt.checked);
				this.filterGroupData[col] = this.filterGroupDataChecked[col]
					.filter(opt => opt.checked).map(op => op.value);

				if (this.filterGroupData[col] != null && this.filterGroupData[col].length == 0) {
					this.filterGroupData[col] = null
					this.filterText[col] = '';
					this.disableButtonFilter[col] = true;
				}
				this.loadTimKiemNangCaoListInit();
			}
		} else {
			let _index = this.filterGroupDataCheckedFake[col].length;
			if (_index > -1) {
				this.filterGroupData[col] = [];
				this.filterGroupArray[col] = [];
				this.filterGroupArray[col] = [];
				this.filterGroupData[col] = [];

				if (this.filterGroupData[col] != null && this.filterGroupData[col].length == 0) {
					this.filterGroupData[col] = null
					this.filterText[col] = '';
					this.disableButtonFilter[col] = true;
				}
				this.filterGroupDataCheckedFake[col] = '';
				this.loadTimKiemNangCaoListInit();
			}
		}

	}
	Clear() {
		this.filterGroupData = [];
		this.filterGroupArray = [];
		for (var key in this.filterGroupDataChecked) {
			if (this.filterGroupDataChecked.hasOwnProperty(key)) {
				if (this.filterGroupDataChecked[key]) {
					this.filterGroupDataChecked[key].forEach(element => {
						element.checked = false;
					});
					this.disableButtonFilter[key] = true;
				}
			}
		}
		for (var key in this.filterText) {
			if (this.filterText.hasOwnProperty(key)) {
				this.filterText[key] = "";
			}
		}
		this.isClearAll = false;
		this.loadTimKiemNangCaoList();
	}

	checkFilterHasValue(data, col, isSelect = true) {
		let _count = 0;
		if (isSelect) {
			if (col == 'ALL' && data) {//check all column
				for (var key in data) {
					if (data.hasOwnProperty(key)) {
						if (data[key]) {
							let _arrflt = data[key].filter(opt => opt.checked);
							_count += _arrflt ? _arrflt.length : 0;
						}
					}
				}
				let _text = "";
				for (var key in this.filterText) {
					if (this.filterText.hasOwnProperty(key)) {
						_text += this.filterText[key];
					}
				}
				if (_count > 0 || _text) {
					return true;
				}
			}
			else {//check in 1 column
				if (data && data[col]) {
					let _arrflt = data[col].filter(opt => opt.checked);
					_count += _arrflt ? _arrflt.length : 0;
				}
				if (_count > 0) {
					return true;
				}
			}
		} else {
			if (data && data[col] && data[col].length > 0) {
				if (data[col].length > 0) {
					return true;
				}
			}
		}
		return false;
	}
	filterGroupWithTextFilter(columnName: string) {
		let search = this.tmpfilterText[columnName]

		if (!search) {
			this.filterGroupDataCheckedFake[columnName] = this.filterGroupDataChecked[columnName].map(x => Object.assign({}, x));
			return;
		} else {
			search = search.toLowerCase();
		}

		this.filterGroupDataCheckedFake[columnName] = this.filterGroupDataChecked[columnName].filter(
			ts => ts.name.toLowerCase().indexOf(search) > -1)

		this.changeDetect.detectChanges();
	}
	//#endregion Filter function

	back() {
		for( let j = 0; j < this.originalTimKiemNangCaoResult.length; j++){
			this.saveAddedTTHV.push(this.originalTimKiemNangCaoResult[j].Id_CT)
		}
		this.dialogRef.close({
			isChange: this.isChange,
			dataAdd: this.saveAddedTTHV
		});
	}

	clickChonHangHoa(item: TimKiemNangCaoModel) {
		if (this.saveAddedTTHV.length > 0 && this.saveAddedTTHV.findIndex(z => z == item.Id_CT) > -1) {
			this.saveAddedTTHV = [];
			return;
		}
		if (this.saveAddedTTHV.findIndex(z => z == item.Id_CT) == -1) this.saveAddedTTHV = [item.Id_CT];
		this.changeDetect.detectChanges();
	}

	checkChonHanghoa(item: TimKiemNangCaoModel) {
		if (this.saveAddedTTHV.findIndex(x => x == item.Id_CT) > -1) return true;
		return false;
	}
	f_number(item: any = "0.00") {
		return FunctionPublic.F_NUMBER(item);
	}
	getFormatDate(v: string = '') {
		if (v != '') {
			return v.includes('T') ? v.replace(/(\d{4})(-)(\d{2})(-)(\d{2})(T)(\d{2})(:)(\d{2})(:)(\d{2}).*$/g, "$5/$3/$1") : v.replace(/(\d{4})(-)(\d{2})(-)(\d{2})/g, "$5/$3/$1");
		}
		return '';
	}
	masterToggle(event) {
		if (event.checked) {
			this.originalTimKiemNangCaoResult = [];
			this.TimKiemNangCaoResult.forEach(element => {
				let id = this.listdachon.findIndex(x=>x.YCBGCT == element.Id_CT);
				if(id == -1){
					let tmp = new TimKiemNangCaoModel();
					tmp.copy(element);
					this.originalTimKiemNangCaoResult.push(tmp)
				}
				
			});
		} else {
			this.originalTimKiemNangCaoResult = [];
		}
		this.changeDetect.detectChanges();
	}
	isAllSelected() {
		if(this.originalTimKiemNangCaoResult.length > 0 && this.TimKiemNangCaoResult.length > 0) {			
			const numSelected = this.originalTimKiemNangCaoResult.length;
			const numRows = this.TimKiemNangCaoResult.length;
			return numSelected == numRows;
		}
		return false
	}

	isChecked(item: any) {
		let _index = this.originalTimKiemNangCaoResult.findIndex(x => x.Id_CT == item.Id_CT);
		if (_index > -1)
			return true;
		return false;
	}
	addremove(event, row) {
		if (event.checked) {
			this.originalTimKiemNangCaoResult.push(row);
		} else {
			let index = this.originalTimKiemNangCaoResult.findIndex(x => x.Id_CT == row.Id_CT);
			if (index > -1) {
				this.originalTimKiemNangCaoResult.splice(index, 1);
			}
			this.originalTimKiemNangCaoResult = [...this.originalTimKiemNangCaoResult];
		}
		this.changeDetect.detectChanges();
	}
	checkdachon(row){
		let id = this.listdachon.findIndex(x=>x.YCBGCT == row.Id_CT);
		return id != -1;
	}
}
